import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { agentState } from "../models/state/AgentState";
import {
  agentTopupAgent,
  createNewAgent,
  editAgentCommission,
  editAgentNickname,
  editAgentShare,
  getAgentList,
  getAgentShareCommission,
  shareAgentInfo,
} from "./AgentCRUD";

export const agentSlice = createSlice({
  name: "agent",
  initialState: agentState,
  reducers: {
    clearAgentList: (state) => {
      state.agentList = agentState.agentList;
    },
    clearAgentInfo: (state) => {
      state.agentInfo = agentState.agentInfo;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAgentList.pending, (state) => {
        state.listLoading = true;
      })
      .addCase(getAgentList.fulfilled, (state, action: PayloadAction<any>) => {
        state.listLoading = false;
        state.agentList = action.payload;
      })
      .addCase(getAgentList.rejected, (state, action: PayloadAction<any>) => {
        state.listLoading = false;
        state.agentList = agentState.agentList;
      })
      .addCase(shareAgentInfo.pending, (state) => {
        state.actionsLoading = true;
      })
      .addCase(
        shareAgentInfo.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.actionsLoading = false;
          state.agentInfo = action.payload;
        }
      )
      .addCase(shareAgentInfo.rejected, (state, action: PayloadAction<any>) => {
        state.actionsLoading = false;
        state.agentInfo = agentState.agentInfo;
      })
      .addCase(getAgentShareCommission.pending, (state) => {
        state.actionsLoading = true;
      })
      .addCase(
        getAgentShareCommission.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.actionsLoading = false;
          state.agentShareCommission = action.payload;
        }
      )
      .addCase(
        getAgentShareCommission.rejected,
        (state, action: PayloadAction<any>) => {
          state.actionsLoading = false;
          state.agentShareCommission = agentState.agentShareCommission;
        }
      )
      .addCase(createNewAgent.pending, (state) => {
        state.actionsLoading = true;
      })
      .addCase(
        createNewAgent.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.actionsLoading = false;
        }
      )
      .addCase(createNewAgent.rejected, (state, action: PayloadAction<any>) => {
        state.actionsLoading = false;
      })
      .addCase(editAgentNickname.pending, (state) => {
        state.actionsLoading = true;
      })
      .addCase(
        editAgentNickname.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.actionsLoading = false;
        }
      )
      .addCase(
        editAgentNickname.rejected,
        (state, action: PayloadAction<any>) => {
          state.actionsLoading = false;
        }
      )
      .addCase(agentTopupAgent.pending, (state) => {
        state.actionsLoading = true;
      })
      .addCase(
        agentTopupAgent.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.actionsLoading = false;
        }
      )
      .addCase(
        agentTopupAgent.rejected,
        (state, action: PayloadAction<any>) => {
          state.actionsLoading = false;
        }
      )
      .addCase(editAgentShare.pending, (state) => {
        state.actionsLoading = true;
      })
      .addCase(
        editAgentShare.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.actionsLoading = false;
        }
      )
      .addCase(editAgentShare.rejected, (state, action: PayloadAction<any>) => {
        state.actionsLoading = false;
      })
      .addCase(editAgentCommission.pending, (state) => {
        state.actionsLoading = true;
      })
      .addCase(
        editAgentCommission.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.actionsLoading = false;
        }
      )
      .addCase(
        editAgentCommission.rejected,
        (state, action: PayloadAction<any>) => {
          state.actionsLoading = false;
        }
      );
  },
});
